// chat-input.ts
import { LitElement, html } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'

@customElement('chat-input')
export class ChatInput extends LitElement {
    @property({ type: Boolean }) isLoading = false
    @state() private _inputValue = ''

    render() {
        return html`
            <e-box>
                <e-cluster nowrap>
                    <e-input
                        .value=${this._inputValue}
                        placeholder="Type your message..."
                        @value-changed=${this._onInputChanged}
                        @enter-pressed=${this._onSend}
                        grow
                    ></e-input>
                    <e-button @click=${this._onSend} ?disabled=${this.isLoading}>Send</e-button>
                </e-cluster>
            </e-box>
        `
    }

    private _onInputChanged(e: CustomEvent<{ value: string }>) {
        this._inputValue = e.detail.value
    }

    private _onSend() {
        if (!this._inputValue.trim()) return
        this.dispatchEvent(
            new CustomEvent('message-submit', {
                detail: { message: this._inputValue.trim() },
                bubbles: true,
                composed: true,
            }),
        )
        this._inputValue = ''
    }
}
